import { z } from 'zod';

import { DisclaimerType } from '../../enums';

export const imageDisclaimerSchema = z.object({
  type: z.literal(DisclaimerType.IMAGE),
  url: z.string(),
});

export type ImageDisclaimerType = z.infer<typeof imageDisclaimerSchema>;
